import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { howlMapper } from 'config/constants/audio'
import { useMemo, useState } from 'react'
import CountUp from 'react-countup'
import { LimboBet } from 'views/InhouseGame/Limbo/config/types'
import { useLimboAction, useLimboBetListener } from 'views/InhouseGame/Limbo/hooks'

const LimboGameResult: React.FC<{ volumeEnable: boolean } & BoxProps> = ({ volumeEnable, ...props }) => {
  const [currentBet, setCurrentBet] = useState<LimboBet>(null)
  const [resultColor, setResultColor] = useState<'textTertiary' | 'error' | 'success'>('textTertiary')
  const { finishBet } = useLimboAction()

  useLimboBetListener((bet: LimboBet) => {
    setCurrentBet(null)
    if (!bet) return
    const timeout = setTimeout(() => {
      const parsedBet: LimboBet =
        bet.resultMultiplier <= 1.01
          ? {
              ...bet,
              disabledDisplay: true,
            }
          : bet

      setCurrentBet(parsedBet)

      if (parsedBet.disabledDisplay) {
        if (parsedBet.resultMultiplier > parsedBet.targetMultiplier) {
          if (volumeEnable) howlMapper.LimboGameBetWin.play()
          setResultColor('success')
        } else {
          setResultColor('error')
        }
        finishBet()
      }
    }, 200)

    return () => {
      clearTimeout(timeout)
    }
  })

  const value = useMemo(() => {
    if (currentBet) {
      return currentBet.resultMultiplier
    }

    return 1
  }, [currentBet])

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100%"
      overflow="hidden"
      height="100%"
      minHeight="180px"
      p={['12px', '', '20px']}
      {...props}
    >
      <Text
        fontSize={['3em', '3em', '5.5em', '5em', '5em', '7em']}
        letterSpacing="0.15em"
        bold
        color={currentBet ? resultColor : 'textTertiary'}
      >
        {!currentBet || currentBet.disabledDisplay ? (
          `${value.toFixed(2)}x`
        ) : (
          <CountUp
            start={1}
            end={value}
            decimals={2}
            duration={0.6}
            onStart={() => {
              if (volumeEnable) howlMapper.LimboGameBetPlaying.play()
            }}
            onEnd={() => {
              finishBet()
              if (value < currentBet?.targetMultiplier) {
                setResultColor('error')
              } else if (volumeEnable) howlMapper.LimboGameBetWin.play()
            }}
            formattingFn={(value) => {
              if (value >= currentBet?.targetMultiplier) {
                setResultColor('success')
              } else {
                setResultColor('textTertiary')
              }

              return `${value.toFixed(2)}x`
            }}
          />
        )}
      </Text>
    </Flex>
  )
}

export default LimboGameResult
